import { action, computed, observable, makeObservable } from 'mobx';
import {logger} from '../../../lib/helpers';
import {HomeworkState} from '../../homework/homework-models';

export class ExamStateStore {
  @observable
  examState: HomeworkState | null;

  constructor() {
    makeObservable(this);
    this.examState = null;
  }

  @computed
  get currentPageId(): number | null {
    return this.examState === null
      ? null
      : this.examState.CurrentPageId;
  }

  @computed
  get currentPushableBlockId(): number | null {
    return this.examState === null
      ? null
      : this.examState.CurrentPushableBlockId;
  }

  @action
  updateExamState = (examState: HomeworkState) => {
    const next = examState;
    // noinspection SuspiciousTypeOfGuard
    if (next === null ||
      next === undefined ||
      typeof next !== 'object' ||
      typeof next.Version !== 'number') {
      logger.error('ExamHubStore.updateState', 'unexpected value for state', next);
      return;
    }
    let current = this.examState;
    if (current === null)
      this.examState = next;
    else if (current.Version <= next.Version)
      this.examState = next;
    else
      logger.log('ExamHubStore: stale version', 'current=', current, 'received=', next);
  };

  @action
  clearExamState = () => {
    this.examState = null;
  };
}

